import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Manyseaterbuses() {



  const cardData = {
"keyword": "32, 35, 40, 45, and 50 Seater Buses on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 32, 35, 40, 45, and 50 Seater Buses on Rent in Pune for corporate travel, wedding transportation, school and college trips, employee transportation, pilgrimage tours, and outstation group journeys. Our large fleet of well-maintained buses is equipped with air-conditioning, comfortable pushback seats, spacious legroom, ample luggage space, and experienced drivers familiar with Pune city and major highway routes. We ensure safe, comfortable, and punctual group transportation with doorstep pickup from all major areas of Pune, suitable for both local and long-distance travel requirements.",

"topPlaces": [
   {
    "title": "Mumbai",
    "description": "Mumbai is a major metro city near Pune, popular for business trips, tourism, beaches, and weekend travel."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill destination near Pune offering cool weather, strawberry farms, viewpoints, and refreshing monsoon scenery."
  },
   {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune featuring lakeside views, colorful architecture, and a peaceful environment for short holidays."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune known for vineyards, temples, and the sacred Trimbakeshwar Jyotirlinga shrine."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort near Pune is a historic hill fort offering trekking routes and panoramic views of the Sahyadri mountains."
  },
   
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town near Pune dedicated to Sai Baba, attracting devotees throughout the year for spiritual visits."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, and weekend getaways, perfect for group and family trips."
  },
  {
    "title": "Karla Bhaja Caves",
    "description": "Karla and Bhaja Caves near Pune are ancient Buddhist rock-cut caves known for historical significance and architectural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake near Lonavala is a popular camping destination offering lakeside stays, bonfires, and adventure activities."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a scenic hill station close to Lonavala, famous for valleys, viewpoints, and monsoon landscapes."
  }
],



services: [
  {
    name: "Pune Bus Rental 32 to 50 Seater",
    description: "Pune bus rental 32 to 50 seater service provides spacious transportation for corporate tours, family vacations, airport transfers, sightseeing journeys, and large group travel requirements. Comfortable seating and ample luggage space ensure smooth journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 32 to 50 seater bus reservations."
  },
  {
    name: "32 35 40 45 50 Seater Bus Pune",
    description: "32 35 40 45 50 seater bus Pune service offers reliable transportation options for school tours, weddings, office outings, pilgrimages, and family group travel. Spacious interiors and comfortable seating ensure pleasant journeys suitable for all types of travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and event venues across Pune. Flexible booking options allow convenient large bus reservations."
  },
  {
    name: "Large Bus Hire Pune",
    description: "Large bus hire Pune service provides dependable transportation for corporate events, tourist groups, educational tours, industrial staff transport, and family functions. Spacious seating and luggage capacity ensure smooth journeys suitable for long-distance and local travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from offices, homes, hotels, and airports across Pune. Flexible booking options allow convenient large bus hire reservations."
  },
  {
    name: "Luxury Coach Rental Pune",
    description: "Luxury coach rental Pune service offers premium transportation with elegant interiors and spacious seating for corporate travel, weddings, sightseeing tours, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, luxury hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury coach reservations."
  },
  {
    name: "Group Travel Bus Pune",
    description: "Group travel bus Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium and large passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Corporate Bus Hire Pune",
    description: "Corporate bus hire Pune service provides professional transportation for office staff, conferences, business meetings, corporate outings, and employee travel requirements. Comfortable seating ensures smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business locations across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Wedding Bus Rental Pune",
    description: "Wedding bus rental Pune service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding bus rental reservations."
  },
  {
    name: "Outstation Bus Hire Pune",
    description: "Outstation bus hire Pune service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient outstation bus hire reservations."
  },
  {
    name: "Pune to Shirdi Large Bus",
    description: "Pune to Shirdi large bus service provides comfortable transportation for pilgrimage tours, Sai Baba temple visits, family trips, and group travel. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance temple tours. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi large bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar Bus Hire",
    description: "Pune to Mahabaleshwar bus hire service offers reliable transportation for hill station vacations, sightseeing tours, weekend trips, and family outings. Comfortable seating and smooth ghat road travel ensure enjoyable journeys suitable for group travel. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Mahabaleshwar bus reservations."
  },
  {
    name: "Pune to Goa Bus Rental",
    description: "Pune to Goa bus rental service provides dependable transportation for beach vacations, sightseeing tours, holiday trips, and group travel requirements. Spacious seating and smooth highway travel ensure comfortable journeys suitable for long-distance tourist travel. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient Goa bus rental reservations."
  },
  {
    name: "Airport Transfer Bus Pune",
    description: "Airport transfer bus Pune service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport transfer bus reservations."
  },
  {
    name: "School Trip Bus Pune",
    description: "School trip bus Pune service provides safe and reliable transportation for educational tours, school picnics, student outings, and academic travel requirements. Spacious buses ensure comfortable journeys suitable for students, teachers, and school groups. Professional drivers ensure punctual transportation and safe driving services throughout the journey. Pickup services are available from schools, homes, and educational institutions across Pune. Flexible booking options allow convenient school trip bus reservations."
  },
  {
    name: "Picnic Bus Pune",
    description: "Picnic bus Pune service provides comfortable transportation for family outings, school trips, office picnics, sightseeing tours, and holiday travel. Spacious buses ensure smooth journeys suitable for local and outstation picnic travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Pune Darshan Bus Rental",
    description: "Pune Darshan bus rental service offers dependable transportation for sightseeing tours, tourist visits, heritage travel, and family outings across Pune city attractions. Spacious seating ensures comfortable journeys suitable for local tourism and group travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the tour route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Pune Darshan bus reservations."
  },
  {
    name: "AC Luxury Bus Pune",
    description: "AC luxury bus Pune service provides premium transportation with modern interiors and comfortable seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient AC luxury bus reservations."
  },
  {
    name: "Non AC Bus Pune Rental",
    description: "Non AC bus Pune rental service offers affordable transportation for educational tours, office travel, sightseeing trips, wedding functions, and group journeys. Spacious seating ensures comfortable travel suitable for budget-friendly local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient non AC bus rental reservations."
  },
  {
    name: "Affordable Bus Hire Pune",
    description: "Affordable bus hire Pune service provides economical transportation for educational tours, office travel, sightseeing journeys, family outings, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient affordable bus hire reservations."
  },
  {
    name: "Premium Coach Pune",
    description: "Premium coach Pune service offers luxury transportation with spacious interiors and comfortable seating for corporate travel, weddings, sightseeing tours, and airport transfers. Smooth journeys and modern amenities ensure pleasant travel experiences suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from hotels, homes, offices, and airports across Pune. Flexible booking options allow convenient premium coach reservations."
  },
  {
    name: "Event Bus Pune",
    description: "Event bus Pune service provides dependable transportation for corporate functions, concerts, exhibitions, weddings, conferences, and social gatherings. Spacious seating ensures smooth journeys suitable for local and outstation event travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and event venues across Pune. Flexible booking options allow convenient event bus reservations."
  },
  {
    name: "Industrial Transport Bus Pune",
    description: "Industrial transport bus Pune service provides reliable transportation for factory workers, industrial staff movement, employee shuttle services, and daily office commute requirements. Spacious seating ensures smooth journeys suitable for workforce transportation and shift travel. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from industrial areas, offices, homes, and MIDC locations across Pune. Flexible booking options allow convenient industrial transport bus reservations."
  },
  {
    name: "Pune Group Tour Bus",
    description: "Pune group tour bus service offers spacious transportation for holiday vacations, sightseeing tours, educational trips, and tourist travel requirements. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient group tour bus reservations."
  },
  {
    name: "Weekend Trip Bus Pune",
    description: "Weekend trip bus Pune service offers comfortable transportation for holiday getaways, hill station tours, sightseeing journeys, and family vacations. Spacious seating and smooth highway travel ensure pleasant travel experiences suitable for local and outstation weekend trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient weekend trip bus reservations."
  },
  {
    name: "Tourist Coach Pune",
    description: "Tourist coach Pune service provides dependable transportation for sightseeing tours, holiday vacations, family outings, and tourist travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation tourism activities. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient tourist coach reservations."
  },
  {
    name: "Private Hire Bus Pune",
    description: "Private hire bus Pune service offers comfortable transportation for family functions, business meetings, airport travel, sightseeing tours, and group travel requirements. Spacious seating ensures smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient private hire bus reservations."
  },
  {
    name: "Intercity Bus Pune",
    description: "Intercity bus Pune service provides dependable transportation for long-distance city travel, business trips, tourist journeys, and family travel requirements. Spacious seating and luggage capacity ensure comfortable highway journeys suitable for local and intercity passenger movement. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient intercity bus reservations."
  }
],

tableData: [
  ["Pune Bus Rental 32 to 50 Seater", "32 35 40 45 50 Seater Bus Pune"],
  ["Large Bus Hire Pune", "Luxury Coach Rental Pune"],
  ["Group Travel Bus Pune", "Corporate Bus Hire Pune"],
  ["Wedding Bus Rental Pune", "Outstation Bus Hire Pune"],
  ["Pune to Shirdi Large Bus", "Pune to Mahabaleshwar Bus Hire"],
  ["Pune to Goa Bus Rental", "Airport Transfer Bus Pune"],
  ["School Trip Bus Pune", "Picnic Bus Pune"],
  ["Pune Darshan Bus Rental", "AC Luxury Bus Pune"],
  ["Non AC Bus Pune Rental", "Affordable Bus Hire Pune"],
  ["Premium Coach Pune", "Event Bus Pune"],
  ["Industrial Transport Bus Pune", "Pune Group Tour Bus"],
  ["Weekend Trip Bus Pune", "Tourist Coach Pune"],
  ["Private Hire Bus Pune", "Intercity Bus Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 32, 35, 40, 45 & 50 Seater Bus Rental in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable bus rental service in Pune with 32, 35, 40, 45, and 50 seater buses suitable for corporate tours, family trips, school travel, and large group transportation."
      },
      {
        WhyChooseheading: "Affordable Large Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable large bus rental packages in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service",
        WhyChoosedescription: "Our large seater bus rental service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, school tours, and holiday travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Bus Options",
        WhyChoosedescription: "All 32, 35, 40, 45, and 50 seater buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable group travel."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Ideal for Corporate, Wedding & School Groups",
        WhyChoosedescription: "Our large seater buses are perfect for corporate outings, wedding guest transport, school excursions, picnic tours, tourist groups, religious tours, and large family vacations."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation large group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What are 32, 35, 40, 45, and 50 seater buses on rent in Pune?", answer: "These are large seating capacity buses available for group transportation in Pune for corporate travel, weddings, school trips, and outstation journeys." },
    { question: "Is large bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 booking service for 32, 35, 40, 45, and 50 seater buses in Pune." },
    { question: "Are AC and Non-AC buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly group travel." },
    { question: "Can I book buses for outstation tours from Pune?", answer: "Yes, customers can book large seater buses for hill stations, pilgrimage tours, holiday trips, and outstation travel from Pune." },
    { question: "Do you provide buses for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides large bus rental services for office outings, conferences, employee transport, and corporate travel." },
    { question: "Can I book buses for weddings and school trips?", answer: "Yes, our 32 to 50 seater buses are ideal for wedding guest transportation, school excursions, and large group travel." },
    { question: "Can I book large seater buses online in Pune?", answer: "Yes, customers can easily book large bus rental services online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using large seating capacity buses." },
    { question: "Are bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for large bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Bhosale",
    feedback:
      "We organized a corporate outing and opted for a 45 Seater Bus rental in Pune. The bus was spacious enough for the entire team, and the journey was comfortable and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rachana Deshpande",
    feedback:
      "A 45 Seater Bus rental in Pune worked perfectly for our large family function travel. The seating was comfortable, the vehicle was clean, and everyone reached the destination without any stress.",
    rating: 5
  }
];
  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32, 35, 40, 45, 50 Seater Bus on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/large-bus-rental-pune.jpg",
  "description": "Book 32, 35, 40, 45, and 50 seater buses on rent in Pune with Aaradhya Travels for corporate travel, weddings, airport transfers, family trips, group tours, and outstation journeys including Shirdi, Mahabaleshwar, and Lonavala. Available AC luxury coaches with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10020"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/large-bus-rental-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>
    32 to 50 Seater Bus Rental in Pune | Luxury Coach Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 32, 35, 40, 45, and 50 seater buses on rent in Pune with Aaradhya Travels. Perfect for corporate events, weddings, group tours, airport transfers, and outstation trips to Shirdi, Mahabaleshwar, and Lonavala."
  />

  <meta
    name="keywords"
    content="Pune bus rental 32 to 50 seater, 32 35 40 45 50 seater bus Pune, large bus hire Pune, luxury coach rental Pune, group travel bus Pune, corporate bus hire Pune, wedding bus rental Pune, outstation bus hire Pune, Pune to Shirdi bus, Pune to Mahabaleshwar bus, Pune to Lonavala bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Manyseaterbuses ;